import { ApiTypes, UITypes } from "types"

export interface KeyIndicatorsTooltipBlock {
  title: string
  items: string[]
}

const DOMAIN_LABELS: Record<string, string> = {
  humidity: "Humidity",
  indoor_air_quality: "IAQ",
  setpoints: "Setpoints",
  sizing_runtime: "Sizing & Runtime",
}

const formatMetricName = (metric: string): string =>
  metric
    .replace(/^median_/, "")
    .replace(/_/g, " ")
    .replace(/^\w/, c => c.toUpperCase())

const formatIndicatorText = (ind: ApiTypes.Model.IntelligenceReportIndicator): string => {
  return `${formatMetricName(ind.metric)}: ${ind.value_raw} → ${ind.meaning_word} (${ind.meaning_range})`
}

const buildTooltipBlocks = (indicators: ApiTypes.Model.IntelligenceReportIndicator[]): KeyIndicatorsTooltipBlock[] => {
  const grouped = new Map<string, string[]>()
  for (const ind of indicators) {
    const domain = ind.domain_code
    if (!grouped.has(domain)) grouped.set(domain, [])
    grouped.get(domain)!.push(formatIndicatorText(ind))
  }
  return Array.from(grouped.entries()).map(([domain, items]) => ({
    title: DOMAIN_LABELS[domain] || domain.replace(/_/g, " ").replace(/^\w/, c => c.toUpperCase()),
    items,
  }))
}

export const convertIntelligenceReportsToTableRows = (
  data: ApiTypes.Model.IntelligenceReport[],
): UITypes.TableBodyRow[] => {
  return data.map(report => {
    const indicators = report.key_indicators
    const displayText = indicators.map(formatIndicatorText).join("; ")
    const tooltipBlocks = buildTooltipBlocks(indicators)

    return {
      sn: { value: report.sn },
      priority: { value: report.priority },
      key_indicators: { value: displayText },
      customer_name: { value: report.customer_name },
      customer_email: { value: report.customer_email },
      rowSettings: {
        id: report.report_id,
        item: {
          ...report,
          key_indicators_tooltip: tooltipBlocks,
        },
      },
    }
  }) as UITypes.TableBodyRow[]
}
